/**
 * Created by hernanherreros on 2019-04-30
 */

import * as React from 'react'

export interface URLParamsContextInterface {
  params?: any;
}

const URLParamsContext = React.createContext<URLParamsContextInterface | null>(null)

export default URLParamsContext
